/** Small wording and number helpers for the dashboard. */

export function plural(count: number, noun: string): string {
  return `${count.toLocaleString()} ${noun}${count === 1 ? '' : 's'}`
}

/** `formatPrice` gives "A$27587.79"; this adds the separators, for figures read at a glance. */
export function withThousands(amount: string): string {
  return amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

/** Whole percent change on last week, or null when there's nothing to compare against. */
export function lastWeekComparison(todayCents: number, lastWeekCents: number): number | null {
  if (lastWeekCents <= 0) return null
  return Math.round(((todayCents - lastWeekCents) / lastWeekCents) * 100)
}
